<template>
  <div>

    <md-card>

      <md-card-content>

        <p>
          イベント名、作成者、日時を入力してください。「*(アスタリスク)」が付いている項目は必須項目です。
        </p>

        <!-- イベントの名称 -->
        <md-input-container
          md-clearable
          v-show="!eventNameError">
          <label>イベント名</label>
          <md-input
            required
            v-model="eventName"></md-input>
        </md-input-container>
        <md-input-container
          md-clearable
          v-show="eventNameError"
          class="md-input-invalid">
          <label>イベント名</label>
          <md-input
            required
            v-model="eventName"></md-input>
          <span
            class="md-error"
            v-model="eventNameError">{{ eventNameError }}</span>
        </md-input-container>

        <!-- 開催者 -->
        <md-input-container
          md-clearable
          v-show="!hostNameError">
          <label>主催者</label>
          <md-input
          required
          v-model="hostName"></md-input>
        </md-input-container>
        <md-input-container
          md-clearable
          v-show="hostNameError"
          class="md-input-invalid">
          <label>主催者</label>
          <md-input
            required
            v-model="hostName"></md-input>
          <span
            class="md-error"
            v-model="hostNameError">{{ hostNameError }}</span>
        </md-input-container>

        <!-- 開始日 -->
        <div class="field-group">
          <md-input-container v-show="!timeError">
            <label for="year">年（開始）</label>
            <md-select
              required
              name="startYear"
              id="startYear"
              v-model="startYear">
              <md-option :value="getCurrentYear">{{ getCurrentYear }}</md-option>
              <md-option :value="getCurrentYear + 1">{{ getCurrentYear + 1 }}</md-option>
            </md-select>
          </md-input-container>
          <md-input-container
            v-show="timeError"
            class="md-input-invalid">
            <label for="year">年（開始）</label>
            <md-select
              required name="startYear"
              id="startYear"
              v-model="startYear">
              <md-option :value="getCurrentYear">{{ getCurrentYear }}</md-option>
              <md-option :value="getCurrentYear + 1">{{ getCurrentYear + 1 }}</md-option>
            </md-select>
          </md-input-container>

          <md-input-container
            v-show="!timeError">
            <label for="month">月（開始）</label>
            <md-select
              required
              name="startMonth"
              id="startMonth"
              v-model="startMonth">
              <md-option
                v-for="(m, index) in 12"
                :key="index"
                :value="m">{{ m }}</md-option>
            </md-select>
          </md-input-container>
          <md-input-container
            v-show="timeError"
            class="md-input-invalid">
            <label for="month">月（開始）</label>
            <md-select
              required
              name="startMonth"
              id="startMonth"
              v-model="startMonth">
              <md-option
                v-for="(m, index) in 12"
                :key="index"
                :value="m">{{ m }}</md-option>
            </md-select>
          </md-input-container>

          <md-input-container v-show="!timeError">
            <label for="date">日（開始）</label>
            <md-select
              required
              name="startDate"
              id="startDate"
              v-model="startDate">
              <md-option
                v-for="(d, index) in 31"
                :key="index"
                :value="d">{{ d }}</md-option>
            </md-select>
          </md-input-container>
          <md-input-container
            v-show="timeError"
            class="md-input-invalid">
            <label for="date">日（開始）</label>
            <md-select
              required
              name="startDate"
              id="startDate"
              v-model="startDate">
              <md-option
                v-for="(d, index) in 31"
                :key="index"
                :value="d">{{ d }}</md-option>
            </md-select>
          </md-input-container>
        </div>

        <!-- 開始時間 -->
        <div class="field-group">
          <md-input-container v-show="!timeError">
            <label for="startHour">時（開始）</label>
            <md-select
              required
              name="startHour"
              id="startHour"
              v-model="startHour">
              <md-option
                v-for="(hh, index) in 23"
                :key="index"
                :value="hh">{{ hh }}</md-option>
            </md-select>
          </md-input-container>
          <md-input-container
            v-show="timeError"
            class="md-input-invalid">
            <label for="startHour">時（開始）</label>
            <md-select
              required
              name="startHour"
              id="startHour"
              v-model="startHour">
              <md-option
                v-for="(hh, index) in 23"
                :key="index"
                :value="hh">{{ hh }}</md-option>
            </md-select>
          </md-input-container>

          <md-input-container v-show="!timeError">
            <label for="startMinute">分（開始）</label>
            <md-select
              required
              name="startMinute"
              id="startMinute"
              v-model="startMinute">
              <md-option value="0">0</md-option>
              <md-option value="5">5</md-option>
              <md-option value="10">10</md-option>
              <md-option value="15">15</md-option>
              <md-option value="20">20</md-option>
              <md-option value="25">25</md-option>
              <md-option value="30">30</md-option>
              <md-option value="35">35</md-option>
              <md-option value="40">40</md-option>
              <md-option value="45">45</md-option>
              <md-option value="50">50</md-option>
              <md-option value="55">55</md-option>
            </md-select>
          </md-input-container>
          <md-input-container
            v-show="timeError"
            class="md-input-invalid">
            <label for="startMinute">分（開始）</label>
            <md-select
              required
              name="startMinute"
              id="startMinute"
              v-model="startMinute">
              <md-option value="0">0</md-option>
              <md-option value="5">5</md-option>
              <md-option value="10">10</md-option>
              <md-option value="15">15</md-option>
              <md-option value="20">20</md-option>
              <md-option value="25">25</md-option>
              <md-option value="30">30</md-option>
              <md-option value="35">35</md-option>
              <md-option value="40">40</md-option>
              <md-option value="45">45</md-option>
              <md-option value="50">50</md-option>
              <md-option value="55">55</md-option>
            </md-select>
          </md-input-container>
        </div>

        <!-- 終了日 -->
        <!-- <div class="field-group">
          <md-input-container v-show="!timeError">
            <label for="year">年（終了）</label>
            <md-select required name="endYear" id="endYear" v-model="endYear">
              <md-option :value="getCurrentYear">{{ getCurrentYear }}</md-option>
              <md-option :value="getCurrentYear + 1">{{ getCurrentYear + 1 }}</md-option>
            </md-select>
          </md-input-container>
          <md-input-container v-show="timeError" class="md-input-invalid">
            <label for="year">年（終了）</label>
            <md-select required name="endYear" id="endYear" v-model="endYear">
              <md-option :value="getCurrentYear">{{ getCurrentYear }}</md-option>
              <md-option :value="getCurrentYear + 1">{{ getCurrentYear + 1 }}</md-option>
            </md-select>
          </md-input-container>

          <md-input-container v-show="!timeError">
            <label for="month">月（終了）</label>
            <md-select required name="endMonth" id="endMonth" v-model="endMonth">
              <md-option v-for="(m, index) in 12" :key="index" :value="m">{{ m }}</md-option>
            </md-select>
          </md-input-container>
          <md-input-container v-show="timeError" class="md-input-invalid">
            <label for="month">月（終了）</label>
            <md-select required name="endMonth" id="endMonth" v-model="endMonth">
              <md-option v-for="(m, index) in 12" :key="index" :value="m">{{ m }}</md-option>
            </md-select>
          </md-input-container>

          <md-input-container v-show="!timeError">
            <label for="date">日（終了）</label>
            <md-select required name="endDate" id="endDate" v-model="endDate">
              <md-option v-for="(d, index) in 31" :key="index" :value="d">{{ d }}</md-option>
            </md-select>
          </md-input-container>
          <md-input-container v-show="timeError" class="md-input-invalid">
            <label for="date">日（終了）</label>
            <md-select required name="endDate" id="endDate" v-model="endDate">
              <md-option v-for="(d, index) in 31" :key="index" :value="d">{{ d }}</md-option>
            </md-select>
          </md-input-container>
        </div> -->

        <!-- 終了時間 -->
        <div class="field-group">
          <md-input-container v-show="!timeError">
            <label for="endHour">時（終了）</label>
            <md-select
              required
              name="endHour"
              id="endHour"
              v-model="endHour">
              <md-option
                v-for="(hh, index) in 23"
                :key="index"
                :value="hh">{{ hh }}</md-option>
            </md-select>
          </md-input-container>
          <md-input-container
            v-show="timeError"
            class="md-input-invalid">
            <label for="endHour">時（終了）</label>
            <md-select
              required
              name="endHour"
              id="endHour"
              v-model="endHour">
              <md-option
                v-for="(hh, index) in 23"
                :key="index"
                :value="hh">{{ hh }}</md-option>
            </md-select>
          </md-input-container>

          <md-input-container v-show="!timeError">
            <label for="endMinute">分（終了）</label>
            <md-select
              required
              name="endMinute"
              id="endMinute"
              v-model="endMinute">
              <md-option value="0">0</md-option>
              <md-option value="5">5</md-option>
              <md-option value="10">10</md-option>
              <md-option value="15">15</md-option>
              <md-option value="20">20</md-option>
              <md-option value="25">25</md-option>
              <md-option value="30">30</md-option>
              <md-option value="35">35</md-option>
              <md-option value="40">40</md-option>
              <md-option value="45">45</md-option>
              <md-option value="50">50</md-option>
              <md-option value="55">55</md-option>
            </md-select>
          </md-input-container>
          <md-input-container
            v-show="timeError"
            class="md-input-invalid">
            <label for="endMinute">分（終了）</label>
            <md-select
              required
              name="endMinute"
              id="endMinute"
              v-model="endMinute">
              <md-option value="0">0</md-option>
              <md-option value="5">5</md-option>
              <md-option value="10">10</md-option>
              <md-option value="15">15</md-option>
              <md-option value="20">20</md-option>
              <md-option value="25">25</md-option>
              <md-option value="30">30</md-option>
              <md-option value="35">35</md-option>
              <md-option value="40">40</md-option>
              <md-option value="45">45</md-option>
              <md-option value="50">50</md-option>
              <md-option value="55">55</md-option>
            </md-select>
          </md-input-container>
        </div>

        <md-input-container md-clearable>
          <label>URL</label>
          <md-input v-model="url"></md-input>
        </md-input-container>

        <md-input-container>
          <label>イベントの説明</label>
          <md-textarea v-model="description"></md-textarea>
        </md-input-container>

        <div>
          <md-radio
            v-model="typeOfEvent"
            id="my-test1"
            name="type-of-evnet"
            md-value="Class">クラス</md-radio>
          <md-radio
            v-model="typeOfEvent"
            id="my-test2"
            name="type-of-evnet"
            md-value="Céilí">ケーリー</md-radio>
          <md-radio
            v-model="typeOfEvent"
            id="my-test2"
            name="type-of-evnet"
            md-value="SessionOrDance">セッション/ダンス</md-radio>
        </div>

      </md-card-content>

      <md-subheader>取り上げる予定のセット</md-subheader>
      <md-divider></md-divider>

      <md-list>
        <md-list-item
          v-for="(set, index) in allSets"
          :key="index"
          class="md-double-line">
          <md-checkbox
            :id="'checkbox' + index"
            name="my-test10"
            :md-value="set.name"
            v-model="selectedSets"
            class="md-primary"></md-checkbox>
          <div class="md-list-text-container">
            <span v-if="set.needsSet">
              {{ set.name }} Set
            </span>
            <span v-else>
              {{ set.name }}
            </span>
            <span v-if="set.needsSet" class="jpCaption">
              {{ set.jpCaption }}・セット
            </span>
            <span v-else class="jpCaption">
              {{ set.jpCaption }}
            </span>
          </div>
          <md-divider></md-divider>
        </md-list-item>
      </md-list>

      <div>
        <md-radio
          v-model="lastSong"
          id="my-test1"
          name="type-of-evnet"
          md-value="anthem">アイルランド国歌</md-radio>
        <md-radio
          v-model="lastSong"
          id="my-test2"
          name="type-of-evnet"
          md-value="shinano">信濃の国</md-radio>
        <md-radio
          v-model="lastSong"
          id="my-test2"
          name="type-of-evnet"
          md-value="none">なし</md-radio>
      </div>

    </md-card>

    <div class="controller">
      <md-button
        class="md-raised"
        @click="openDialog('deleteEventDialog')">削除する</md-button>
      <md-button
        class="md-raised md-primary"
        @click="setEvent('dialog5')">更新する</md-button>
    </div>

    <md-dialog
      md-open-from="#custom"
      md-close-to="#custom"
      ref="deleteEventDialog">
      <md-dialog-title>イベントを削除します</md-dialog-title>

      <md-dialog-content>
        この操作は取り消せません。{{ event.name }}を削除しますか？

      </md-dialog-content>

      <md-dialog-actions>
        <md-button
          class="md-primary"
          @click="cancelDialog('deleteEventDialog')">キャンセル</md-button>
        <md-button
          class="md-primary"
          @click="deleteEvent('deleteEventDialog')">削除する</md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-dialog-confirm
      :md-title="confirm.title"
      :md-content-html="confirm.contentHtml"
      :md-ok-text="confirm.ok"
      :md-cancel-text="confirm.cancel"
      @open="onOpen"
      @close="onClose"
      ref="dialog5">
    </md-dialog-confirm>

    <form novalidate @submit.stop.prevent="openErrorConsole">
      <md-snackbar
        :md-position="'top center'"
        ref="snackbar"
        :md-duration="4000">
        <span>{{ timeError }}</span>
      </md-snackbar>
    </form>

  </div>
</template>

<script>
import db from '../db'

// db.ref('/events').once('value').then(function (events) {
//   console.log(events.val())
// })
// db.ref('/events/').remove()

export default {
  name: 'event',
  data () {
    return {
      eventId: this.$route.params.eventId,
      eventName: '',
      hostName: '',
      startYear: '',
      startMonth: '',
      startDate: '',
      startHour: '',
      startMinute: '',
      endYear: '',
      endMonth: '',
      endDate: '',
      endHour: '',
      endMinute: '',
      typeOfEvent: '',
      url: '',
      description: '',
      selectedSets: [],
      lastSong: 'none',
      eventNameError: '',
      hostNameError: '',
      timeError: '',
      event: {},
      confirm: {
        title: '以下の内容でイベントを作成します。よろしいですか？',
        contentHtml: 'content',
        ok: '作成する',
        cancel: 'キャンセル'
      }
    }
  },
  firebase: {
    event: db.ref('/events/' + this.eventId),
    allSets: db.ref('/sets')
  },
  computed: {
    getCurrentYear () {
      return new Date().getFullYear()
    },
    getCurrentMonth () {
      return new Date().getMonth()
    },
    getCurrentDate () {
      return new Date().getDate()
    }
  },
  created () {
    let self = this
    db.ref('/events/' + this.eventId).once('value').then(function (event) {
      self.event = event.val()
      self.setEventData()
    })
  },
  watch: {
    '$route': 'refreashData'
  },
  // beforeRouteEnter: (to, from, next) => {
  //   let self = this
  //   db.ref('/events/' + this.eventId).once('value').then(function (event) {
  //     next((vm) => {
  //       vm.event = event.val()
  //       self.setEventData()
  //     })
  //   })
  // },
  methods: {
    refreashData () {
      let self = this
      db.ref('/events/' + this.eventId).once('value').then(function (event) {
        self.$set(self, 'event', event.val())
        self.setEventData()
      })
    },
    setEventData () {
      this.eventName = this.event.name
      this.hostName = this.event.host
      this.startYear = Number(new Date(this.event.startTime).getFullYear().toString())
      this.startMonth = Number((new Date(this.event.startTime).getMonth() + 1).toString())
      this.startDate = Number(new Date(this.event.startTime).getDate().toString())
      this.startHour = Number(new Date(this.event.startTime).getHours().toString())
      this.startMinute = new Date(this.event.startTime).getMinutes().toString()
      // this.endYear = this.event.endYear
      // this.endMonth = this.event.endMonth
      // this.endDate = this.event.endDate
      this.endHour = Number(new Date(this.event.endTime).getHours().toString())
      this.endMinute = new Date(this.event.endTime).getMinutes().toString()
      this.typeOfEvent = this.event.type
      this.lastSong = this.event.lastSong === undefined ? 'none' : this.event.lastSong
      this.url = this.event.url === undefined ? '' : this.event.url
      this.description = this.event.description === undefined ? '' : this.event.description
      this.selectedSets = this.event.sets === undefined ? [] : this.event.sets
    },
    deleteEvent (ref) {
      let self = this
      db.ref('/events/' + self.eventId).remove().then(function () {
        self.$router.push({ name: 'Home' })
      })
    },
    cancelDialog (ref) {
      this.$refs[ref].close()
    },
    setEvent (ref) {
      // <strong>anonymous</strong>
      let isError = false

      if (this.eventName === '') {
        this.eventNameError = 'イベント名を入力してください。'
        isError = true
      } else {
        this.eventNameError = ''
      }

      if (this.hostName === '') {
        this.hostNameError = '作成者を入力してください。'
        isError = true
      } else {
        this.hostNameError = ''
      }

      // 日付入力を簡易にする
      this.endYear = this.startYear
      this.endMonth = this.startMonth
      this.endDate = this.startDate

      if (new Date(this.startYear + '-' + this.startMonth + '-' + this.startDate + ' ' + this.startHour + ':' + this.startMinute + ':00') - new Date(this.endYear + '-' + this.endMonth + '-' + this.endDate + ' ' + this.endHour + ':' + this.endMinute + ':00') > 0) {
        this.timeError = '開始時刻が終了時刻よりも遅い時間になっています。開始時刻は終了時刻よりも早い時間にしてください。'
        isError = true
        this.$refs.snackbar.open()
      } else if ((this.startYear + '-' + this.startMonth + '-' + this.startDate + ' ' + this.startHour + ':' + this.startMinute + ':00') === (this.endYear + '-' + this.endMonth + '-' + this.endDate + ' ' + this.endHour + ':' + this.endMinute + ':00')) {
        this.timeError = '開始時刻が終了時刻と同じ時間になっています。開始時刻は終了時刻よりも早い時間にしてください。'
        isError = true
        this.$refs.snackbar.open()
      } else {
        this.timeError = ''
      }

      if (isError) {
        return
      }

      let zeroFill = require('zero-fill')
      let typeOfEvent = ''

      switch (this.typeOfEvent) {
        case 'Ceili':
          typeOfEvent = 'ケーリー'
          break
        case 'Class':
          typeOfEvent = 'クラス'
          break
        case 'SessionOrDance':
          typeOfEvent = 'セッション/ダンス'
          break
        default:
          typeOfEvent = 'ケーリー'
          break
      }

      this.confirm.contentHtml = 'イベント名：' + this.eventName + '<br />作成者：' + this.hostName + '<br />日時：' + this.startYear + '年' + this.startMonth + '月' + this.startDate + '日 ' + zeroFill(2, this.startHour) + ':' + zeroFill(2, this.startMinute) + '〜' + zeroFill(2, this.endHour) + ':' + zeroFill(2, this.endMinute) + '<br />イベントの種類：' + typeOfEvent + '<br />' + 'URL：' + this.url + '<br />イベントの説明：' + this.description.replace(/\n/g, '<br/>') + '<br />取り上げる予定のセット：' + this.selectedSets

      this.$refs[ref].open()
    },
    openDialog (ref) {
      this.$refs[ref].open()
    },
    closeDialog (ref) {
      this.$refs[ref].close()
    },
    onOpen () {
    },
    onClose (type) {
      if (type !== 'ok') { return }
      let self = this
      let zeroFill = require('zero-fill')
      db.ref('/events/' + this.eventId).set({
        id: self.eventId,
        name: this.eventName,
        host: this.hostName,
        date: this.startYear + '-' + zeroFill(2, this.startMonth) + '-' + zeroFill(2, this.startDate),
        index: Date.parse(new Date(this.startYear, this.startMonth - 1, this.startDate, this.startHour, this.startMinute)) * -1,
        dateTime: Date.parse(new Date(this.endYear + '-' + zeroFill(2, this.endMonth) + '-' + zeroFill(2, this.endDate) + 'T' + zeroFill(2, this.endHour) + ':' + zeroFill(2, this.endMinute) + ':00')),
        startTime: new Date(this.startYear, this.startMonth - 1, this.startDate, this.startHour, this.startMinute).toISOString(),
        endTime: new Date(this.startYear, this.startMonth - 1, this.startDate, this.endHour, this.endMinute).toISOString(),
        type: this.typeOfEvent,
        description: this.description === undefined ? '' : this.description,
        url: this.url === undefined ? '' : this.url,
        sets: this.selectedSets,
        lastSong: this.lastSong
      }).then(function () {
        self.$router.push({ name: 'Event', params: { eventId: self.eventId } })
      })
      // .catch(function (error) {})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.field-group {
  display: -webkit-flex; /* Safari */
  display: flex;
}
.md-input-container {
  /*display: flex;*/
}

h1, h2 {
  font-weight: normal;
}

.md-avatar.md-large {
  width: 113px;
  max-width: 113px;
  min-width: 113px;
}

.md-avatar {
  overflow: inherit;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  /*display: inline-block;*/
  margin: 0 10px;
}

a {
  color: #42b983;
}

</style>



// WEBPACK FOOTER //
// EditEvent.vue?22dc9680